import { useStrings } from '../locales';

export default function About() {
  const s = useStrings();
  return (
    <div className="page-content about-page">
      <h2>{s.about.title}</h2>

      <section className="about-section">
        <h3>{s.about.projectHeading}</h3>
        <p>{s.about.projectText}</p>
        <p>© {new Date().getFullYear()} DHTools</p>
      </section>

      <section className="about-section">
        <h3>{s.about.makerHeading}</h3>
        <p>{s.about.makerText}</p>
      </section>

      <section className="about-section">
        <h3>{s.about.accuracyHeading}</h3>
        <p>{s.about.accuracyText}</p>
      </section>

      <section className="about-section">
        <h3>{s.about.daggerforgeHeading}</h3>
        <p>{s.about.daggerforgeText}</p>
        <div className="about-links">
          <a
            href="https://github.com/Torutu/daggerforge"
            target="_blank"
            rel="noopener noreferrer"
            className="about-link"
          >
            {s.about.daggerforgeGithub}
          </a>
          <a
            href="https://obsidian.md/plugins?id=daggerforge"
            target="_blank"
            rel="noopener noreferrer"
            className="about-link"
          >
            {s.about.daggerforgePlugin}
          </a>
        </div>
      </section>

      <section className="about-section">
        <h3>{s.about.contactHeading}</h3>
        <p>{s.about.contactText}</p>
        <div className="about-links">
          <a href="mailto:waleedalnaimi117@gmail.com" className="about-link">
            waleedalnaimi117@gmail.com
          </a>
          <a
            href="https://www.linkedin.com/in/walnaimi/"
            target="_blank"
            rel="noopener noreferrer"
            className="about-link"
          >
            {s.about.contactLinkedIn}
          </a>
        </div>
      </section>

      <section className="about-section">
        <h3>{s.about.supportHeading}</h3>
        <p>{s.about.supportText}</p>
        <a href="https://ko-fi.com/waleedalnaimi" target="_blank" rel="noopener noreferrer" className="kofi-btn about-kofi">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="15" height="15" style={{ verticalAlign: 'middle', marginRight: '5px' }}>
            <path d="M23.881 8.948c-.773-4.085-4.859-4.593-4.859-4.593H.723c-.604 0-.679.798-.679.798s-.082 7.324-.022 11.822c.164 2.424 2.586 2.672 2.586 2.672s8.267-.023 11.966-.049c2.438-.426 2.683-2.566 2.658-3.734 4.352.24 7.422-2.831 6.649-6.916zm-11.062 3.511c-1.246 1.453-4.011 3.976-4.011 3.976s-.121.119-.31.023c-.076-.057-.108-.09-.108-.09-.443-.441-3.368-3.049-4.034-3.954-.709-.965-1.041-2.7-.091-3.71.951-1.01 3.005-1.086 4.363.407 0 0 1.565-1.782 3.468-.963 1.904.82 1.832 3.011.723 4.311zm6.173.478c-.928.116-1.682.028-1.682.028V7.284h1.77s1.971.551 1.971 2.638c0 1.913-.985 2.667-2.059 3.015z" />
          </svg>
          {s.about.kofi}
        </a>
      </section>

      <section className="about-section">
        <h3>{s.about.licenseHeading}</h3>
        <p>
          {s.about.srd}{' '}
          <a href="https://darringtonpress.com/license" target="_blank" rel="noopener noreferrer">
            {s.about.licenseLink}
          </a>.
        </p>
        <a
          href="https://darringtonpress.com/license"
          target="_blank"
          rel="noopener noreferrer"
          className="dh-badge-link"
          title="Daggerheart Compatible, Community Gaming License"
          style={{ marginTop: '12px', display: 'inline-flex' }}
        >
          <img className="dh-badge dh-badge--dark" src="/dh-compatible/dh-compatible-white.svg" alt={s.about.badgeAlt} />
          <img className="dh-badge dh-badge--light" src="/dh-compatible/dh-compatible-color.svg" alt={s.about.badgeAlt} />
        </a>
      </section>
    </div>
  );
}
